<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
           <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp;Cek Kredit</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mb-4">Cek Kredit</h5>
            </div>
            <div class="container">
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  Nama Perusahaan
                </div>
                <div class="col-lg-10 pl-0">
                  <multiselect v-model="company" :options="searchData" label="companyName" :allow-empty="false" deselect-label="Can't remove this value" :searchable="true" @search-change="searchCompany" :loading="isLoading" placeholder="Nama Perusahaan" aria-placeholder="Nama Perusahaan">
                    <span slot="noOptions"></span>
                  </multiselect>
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  Jumlah Karyawan
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="number" v-model="employeeCount" class="form-control" placeholder="Jumlah Karyawan">
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  Tanggal Berdiri Perusahaan
                </div>
                <div class="col-lg-10 pl-0">
                  <!-- <input type="date" class="form-control w-100" name="deliver_schedule" v-model="createdAt"> -->
                  <datepicker required :language="lang" :typeable="true" placeholder="Tanggal Berdiri Perusahaan" input-class="form-control w-100 bg-light" v-model="createdAt" name="createdAt" format="dd-MM-yyyy"></datepicker>
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  Jabatan
                </div>
                <div class="col-lg-10 pl-0">
                  <select name="jabatan" id="jabatan" class="form-control w-100" v-model="jabatan">
                    <option value="" disabled selected>Pilih Jabatan</option>
                    <option v-for="(pos,i) in posOpt" :key="`pos-${i}`" :value="pos">{{pos}}</option>
                    <option value="lain - lain">Lain - lain</option>
                  </select>
                </div>
              </div>
              <div class="row align-items-center my-2" v-if="jabatan == 'lain - lain'">
                <div class="col-lg-2">

                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="customPos" class="form-control" placeholder="Masukkan Jabatan">
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  Nama {{jabatan !== '' && jabatan !== 'lain - lain' ? jabatan : customPos}}
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="picName" class="form-control" placeholder="Masukkan Nama">
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  LinkedIn(url)
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="linkedIn" class="form-control" placeholder="url linkedIn">
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  Kredibilitas Manajemen
                </div>
                <div class="col-lg-10 pl-0">
                  <select name="kredibilitas" id="kredibilitas" class="form-control w-100" v-model="kredibilitas">
                    <option value="" disabled selected>Pilih Kredibilitas</option>
                    <option v-for="(opt,i) in credibilityOpt" :key="`credibilityOpt-${i}`" :value="opt">{{opt}}</option>
                  </select>
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-2">
                  Kredit Cek
                </div>
                <div class="col-lg-10 pl-0">
                  <select name="kreditCek" id="kreditCek" class="form-control w-100" v-model="kreditCek">
                    <option value="" disabled selected>Pilih Kredit</option>
                    <option v-for="(opt,i) in creditOpt" :key="`creditOpt-${i}`" :value="opt">{{opt}}</option>
                  </select>
                </div>
              </div>
              <div class="container">
                <div class="row align-items-center justify-content-end my-3">
                  <button class="btn btn-secondary mx-2" @click="reset">Reset</button>
                  <button class="btn btn-primary" @click="doCalculate" :disabled="!company.companyId || jabatan == 'Pilih Jabatan' || customPos == '' || kredibilitas == '' || kreditCek == '' || createdAt == null || createdAt == ''">Kalkulasi</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid" v-if="loadingTable == true">
        <div class="row justify-content-center">
          <div><img src="~@/assets/images/load-button.gif" /></div>
        </div>
      </div>
      <div class="container-fluid" v-if="calculationResult.score && loadingTable == false">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mb-4 font-weight-bold">Hasil Kalkulasi</h5>
            </div>
            <div class="container">
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Golongan Skor
                </div>
                <div class="col-lg-6 pl-0">
                  {{calculationResult.score}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Batas maksimal total aset
                </div>
                <div class="col-lg-6 pl-0">
                  Rp {{calculationResult.assetLimit}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Estimasi total aset sedang disewa
                </div>
                <div class="col-lg-6 pl-0">
                  Rp {{calculationResult.assetRentingEst}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Total aset sedang disewa
                </div>
                <div class="col-lg-6 pl-0">
                  {{calculationResult.assetRenting}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Maksimum durasi yang diberikan
                </div>
                <div class="col-lg-6 pl-0">
                  {{calculationResult.durationMax}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Status barang yang dapat disewakan
                </div>
                <div class="col-lg-6 pl-0">
                  {{calculationResult.productStatus}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Minimal deposit yang dibutuhkan
                </div>
                <div class="col-lg-6 pl-0">
                  {{calculationResult.depositMin}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Usia perusahaan
                </div>
                <div class="col-lg-6 pl-0">
                  {{calculationResult.companyAge}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-6">
                  Nilai kontrak yang belum dibayarkan
                </div>
                <div class="col-lg-6 pl-0">
                  {{calculationResult.unpaidContract}}
                </div>
              </div>
              <div class="row align-items-center my-2">
                <div class="col-lg-12">
                  Riwayat transaksi (6 bulan terakhir)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid my-2" v-if="calculationResult.historyTransaction && loadingTable == false">
        <div class="container" v-for="(history,i) in calculationResult.historyTransaction" :key="`history-${i}`">
          <h6 class="font-weight-bold my-3" v-if="history.transaction.length">{{history.companyName}}</h6>
          <div class="row flex-wrap px-2">
            <div class="col-md-4 px-2 mb-3" v-for="(trans,j) in history.transaction" :key="`hist-${trans.transactionNo}-${j}`">
              <div class="col-lg-12 px-2 py-3 border rounded" style="min-height: 150px;">
                <div class="font-weight-bold mb-2">{{trans.transactionNo}} ({{trans.status}})</div>
                <div>Total Tagihan : {{trans.total}}</div>
                <div>Sisa Tagihan : {{trans.balanceDue}}</div>
                <div>Tgl. jatuh tempo : {{trans.dueDate}}</div>
                <div v-if="trans">
                  <div v-for="(pay,k) in trans.paymentDate" :key="`payment${trans.transactionNo}-${k}`">Tgl. bayar : {{pay.date}} {{pay.transactionNo.split(' ')[2]}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid my-2" v-if="loadingTable == false && calculationResult.score">
        <div class="container">
          <div class="container">
            <div class="row align-items-center my-2">
              <div class="col-lg-2">
                Finalisasi Golongan Skor
              </div>
              <div class="col-lg-10 pl-0">
                <select name="kreditCek" id="kreditCek" class="form-control w-100" v-model="finalScore">
                  <option value="" disabled selected>Pilih Skor</option>
                  <option v-for="(_,i) in 5" :key="`opt-${i}`" :value="i+1">{{i+1}}</option>
                </select>
              </div>
            </div>
            <div class="row align-items-center justify-content-end">
              <button class="btn btn-primary" @click.prevent="save" v-if="!loadingBtnSave">Simpan</button>
              <button type="button" class="btn btn-primary" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Loading</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SideBar from '../SideBar'
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import { id } from 'vuejs-datepicker/dist/locale'
export default {
  name: 'CekSkor',
  components: {
    SideBar,
    Multiselect,
    Datepicker
  },
  data() {

    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin: '',
      permission: [],
      company: [],
      employeeCount: '',
      createdAt: '',
      jabatan: '',
      customPos: '',
      picName: '',
      linkedIn: '',
      kredibilitas: '',
      kreditCek: '',
      searchData: [],
      posOpt: [],
      credibilityOpt: [],
      creditOpt: [],
      finalScore: '',
      isLoading: false,
      loadingTable: false,
      calculationResult: {},
      loadingBtnSave: false,
      viewEmployee: true,
      lang: id
    }
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('dd-MM-YYYY, h:mm:ss a');
    },
    toPage(e) {
      this.$router.push(e)
    },
    reset() {
      this.company = []
      this.employeeCount = ''
      this.createdAt = ''
      this.jabatan = ''
      this.picName = ''
      this.linkedIn = ''
      this.kredibilitas = ''
      this.kreditCek = ''
      this.searchData = []
      this.calculationResult = [],
        this.finalScore = ''
    },
    searchCompany(query) {
      if (query.length > 2) {
        this.isLoading = true
        this.$http.post(process.env.SEARCH_COMPANY, {
            companyName: query
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") }
          })
          .then(res => {
            this.isLoading = false
            if (res.data.status == 200) {
              if (Array.isArray(res.data.data[0])) {
                this.searchData = []
              } else {
                this.searchData = res.data.data
              }
            } else if (res.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                button: "Ok",
              })
            }
          })
          .catch(error => {
            this.isLoading = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    clearAll() {
      this.company = []

    },
    getPosition() {
      // try {
      //   const res = await this.$http.get(process.env.GET_POSITION, {
      //     headers: { "Asani-Token": localStorage.getItem("jwt") }
      //   })
      //   if(res) {
      //     this.posOpt = res.data.data
      //   }
      // } catch(err) {
      //   console.log(err)
      //   window.location.reload()
      // }
      this.$http.get(process.env.GET_POSITION, {
          headers: { "Asani-Token": localStorage.getItem("jwt") }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.posOpt = res.data.data
          } else if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getCredibility() {
      // try {
      //   const res = await this.$http.get(process.env.GET_CREDIBILITY, {
      //     headers: { "Asani-Token": localStorage.getItem("jwt") }
      //   })
      //   if(res) {
      //     this.credibilityOpt = res.data.data
      //   }
      // } catch(err) {
      //   console.log(err)
      //   window.location.reload()
      // }
      this.$http.get(process.env.GET_CREDIBILITY, {
          headers: { "Asani-Token": localStorage.getItem("jwt") }
        })
        .then(res => {
          if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
            this.handleLogout()
          } else {
            this.credibilityOpt = res.data.data
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getCredit() {
      // try {
      //   const res = await this.$http.get(process.env.GET_CREDIT, {
      //     headers: { "Asani-Token": localStorage.getItem("jwt") }
      //   })
      //   if(res) {
      //     this.creditOpt = res.data.data
      //   }
      // } catch(err) {
      //   console.log(err)
      //   window.location.reload()
      // }
      this.$http.get(process.env.GET_CREDIT, {
          headers: { "Asani-Token": localStorage.getItem("jwt") }
        })
        .then(res => {
          if (res.data.status == 200) {
            console.log('cred', res)
            this.creditOpt = res.data.data
          } else if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    doCalculate() {
      this.loadingTable = true
      this.$http.post(process.env.CALCULATE_SCORE, {
          companyId: this.company.companyId,
          companyName: this.company.companyName,
          numberOfEmployee: this.employeeCount,
          companyCreatedDate: this.createdAt,
          position: this.customPos !== null ? this.customPos.replace(this.spaceRegex, ' ') : this.customPos,
          contactName: this.picName !== null ? this.picName.replace(this.spaceRegex, ' ') : this.picName,
          url: this.linkedIn,
          credibility: this.kredibilitas !== null ? this.kredibilitas.replace(this.spaceRegex, ' ') : this.kredibilitas,
          creditCheck: this.kreditCek !== null ? this.kreditCek.replace(this.spaceRegex, ' ') : this.kreditCek
        }, {
          headers: { "Asani-Token": localStorage.getItem("jwt") }
        })
        .then(res => {
          this.loadingTable = false
          if (res.data.status == 200) {
            this.calculationResult = res.data.data
          } else if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
        })
        .catch(error => {
          this.loadingTable = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          });
        })
    },
    save() {
      this.loadingBtnSave = true
      this.$http.post(process.env.SAVE_SCORE, {
          companyId: this.company.companyId,
          companyName: this.company.companyName,
          numberOfEmployee: this.employeeCount,
          companyCreatedDate: this.createdAt,
          position: this.customPos !== null ? this.customPos.replace(this.spaceRegex, ' ') : this.customPos,
          contactName: this.picName !== null ? this.picName.replace(this.spaceRegex, ' ') : this.picName,
          url: this.linkedIn,
          credibility: this.kredibilitas !== null ? this.kredibilitas.replace(this.spaceRegex, ' ') : this.kredibilitas,
          creditCheck: this.kreditCek !== null ? this.kreditCek.replace(this.spaceRegex, ' ') : this.kreditCek,
          calculateResult: this.calculationResult,
          finalScore: this.finalScore
        }, { headers: { "Asani-Token": localStorage.getItem("jwt") } })
        .then(res => {
          if (res.data.status !== 200) {
            swal('Error', res.data.message, 'error')
            this.loadingBtnSave = false
          } else if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          } else {
            this.loadingBtnSave = false
            swal('Sukses', 'Data berhasil disimpan', 'success')
          }
        })
        .catch(error => {
          this.loadingBtnSave = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push('/')
      }
    },
  },
  watch: {
    company: {
      handler: function (val) {
        console.log(val)
        if (val.companyFoundingDate !== '' || val.companyFoundingDate !== null) {
          this.createdAt = val.companyFoundingDate
        }
      }
    },
    companyName: {
      handler: function (val) {
        console.log(val)
        if (val.length > 2) {
          this.searchCompany()
          this.getPosition()
        }
      }
    },
    jabatan: {
      handler: function (val) {
        if (val !== 'lain - lain' && val !== '') {
          this.customPos = val
        }
        if (val == 'lain - lain') {
          this.customPos = ''
        }
      }
    }
  },
  async created() {
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
    this.getPosition()
    this.getCredibility()
    this.getCredit()
  },
  mounted() {
    this.getPosition()
    this.getCredibility()
    this.getCredit()
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RiskManagement/riskmg.vue